import Cookies from "js-cookie";
import * as React from "react";

export const setSessionCookie = (session) => {
    Cookies.remove("sessionId");
    Cookies.set("sessionId", session, { expires: 14 });
};

export const getSessionCookie = () => {
    const sessionId = Cookies.get("sessionId");

    return sessionId || null;
};

export const removeSessionCookie = () => {
    Cookies.remove("sessionId");
};

export const SessionContext = React.createContext(getSessionCookie());